import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, GraduationCap, BadgeCheck, Leaf, LogIn } from "lucide-react";
import { Button } from "./ui/button";

const PILASTRI = [
  {
    icon: GraduationCap,
    titolo: "Formazione certificata",
    testo: "Percorsi tracciati con verifica della presenza, esame finale in formato ministeriale, crediti CFDT annuali e guide pratiche per professionisti, aziende e privati.",
  },
  {
    icon: ShieldCheck,
    titolo: "Tutela digitale",
    testo: "Sportello del consumatore digitale, consulenza legale per i soci, educazione alla sicurezza informatica e alla protezione dei dati personali (GDPR).",
  },
  {
    icon: BadgeCheck,
    titolo: "Registro Nazionale",
    testo: "Qualificazione professionale ex Legge 4/2013 con tessera digitale QR verificabile pubblicamente: chiunque può controllare in pochi secondi chi è un professionista qualificato.",
  },
  {
    icon: Leaf,
    titolo: "Sostenibilità e territorio",
    testo: "Promuoviamo una digitalizzazione sostenibile e accessibile: eventi, community di professionisti e progetti che accelerano la trasformazione digitale del territorio.",
  },
];

export default function About() {
  return (
    <section id="chi-siamo" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7 reveal">
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">
              Chi Siamo
            </div>
            <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.08]">
              Connettiamo persone, competenze
              <br className="hidden md:block" /> e <span className="text-[#102a6b]">futuro digitale</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 reveal">
            <p className="text-slate-600 text-lg leading-relaxed">
              ACDT è il punto di incontro tra <strong className="text-[#102a6b]">conoscenza, tecnologia e responsabilità digitale</strong>.
              Un ecosistema che unisce formazione, professionisti e imprese per accelerare la trasformazione digitale del territorio.
            </p>
          </div>
        </div>

        {/* Descrizione estesa dell'Associazione */}
        <div className="mt-10 grid lg:grid-cols-12 gap-8 reveal" data-testid="about-descrizione">
          <div className="lg:col-span-5">
            <div className="rounded-3xl bg-[#0a1f55] text-white p-7 md:p-8 h-full">
              <div className="text-[11px] font-bold tracking-[0.22em] uppercase text-[#f59e0b]">La nostra missione</div>
              <p className="mt-4 text-[15px] leading-relaxed text-slate-200">
                L'<strong className="text-white">Associazione Consulenti e Consumatori Digitali, Tecnologici e di Sostenibilità</strong> nasce
                per dare al mercato una figura professionale riconoscibile e verificabile — il{" "}
                <strong className="text-white">Consulente Digitale, Tecnologico e di Sostenibilità</strong> — e per tutelare
                chi il digitale lo vive ogni giorno: cittadini, professionisti e imprese.
              </p>
              <p className="mt-4 text-[15px] leading-relaxed text-slate-200">
                Lo facciamo con <strong className="text-white">corsi interattivi</strong> a frequenza tracciata,
                <strong className="text-white"> guide pratiche</strong>, uno sportello di <strong className="text-white">tutela digitale</strong> e
                un <strong className="text-white">Registro Nazionale</strong> pubblico, nel quadro della Legge 4/2013 e
                dell'Aggregazione MIMIT.
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link to="/area-soci">
                  <Button data-testid="about-accesso-soci" className="bg-[#1e40af] hover:bg-[#1e3a8a] text-white font-bold shadow-md">
                    <LogIn className="mr-2 h-4 w-4" />
                    Accesso Soci
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
                <a href="#tesseramento">
                  <Button variant="outline" className="border-white/30 bg-transparent text-white hover:bg-white/10">
                    Scopri il Tesseramento
                  </Button>
                </a>
              </div>
            </div>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {PILASTRI.map((p) => (
              <div key={p.titolo} className="rounded-2xl border border-slate-200 bg-white p-6 hover:shadow-lg hover:border-[#102a6b]/30 transition-all">
                <div className="h-11 w-11 rounded-xl bg-[#102a6b]/8 bg-slate-100 text-[#102a6b] flex items-center justify-center">
                  <p.icon className="h-5 w-5" />
                </div>
                <h3 className="mt-3 font-extrabold text-[#0a1f55] text-[15px]">{p.titolo}</h3>
                <p className="mt-1.5 text-[13px] text-slate-600 leading-relaxed">{p.testo}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
